<template>
  <div class="card-item" 
       @mouseleave="showListFlag=false">
    <div class="card-body">
      <div class="image"
           v-if="o.img"
           @click="toRead(o)"
           v-bind:style="{ backgroundImage:'url('+o.img+')'}"></div>
      <!-- v-lazy:background-image ="o.img" -->
      <div class="card-info"
           @click="toRead(o)">
        <div class="card-title">{{o.title}}</div>
        <div class="card-des">{{!o.img?o.desc:null}}</div>
      </div></div>
    <div class="bottom">
      <div class="web-link"
           @click="toRead(o)">
        <img :src="o.favicon" alt="" />
        <span>{{o.orig}}</span>
      </div>
      <div class="card-operation">
        <div :class="['share-list', 'en-share-list' , {'isEngCss':isChinese}]"
             @mouseleave="showListFlag=false">
          <ShareList v-if="showListFlag && o.public"
                     v-bind:url="o.link"
                     v-bind:imgUrl="o.img || ''"
                     v-bind:des="o.desc"
                     v-bind:public_url ="o.public_url|| ''"
                     v-bind:title="o.title"
                     v-bind:id="o.id"
                     @refreshList="changedata"></ShareList>
        </div>
        <div v-bind:class="['share','share-button',{'hover':o.public}]"
             @click="openShare(o)"
             @mouseenter="showListFlag=true"></div>
        <div
          @click="collection(o)"
          v-bind:class="['share-button','collection',{'active':isCollection}]"></div>
      </div>
    </div>
  </div>
</template>
<style scoped>
  .card-item{
    position: relative;
    width:100%;
    height:100%;
    cursor: pointer;
    overflow: inherit;
  }
  .card-item:hover .card-title{
    color: #5ebb8d;
  }
  .card-item:hover .card-operation{
    opacity: 1;
  }
  .bottom .card-operation{
    position: absolute;
    right: 0;
    opacity: 0;
    -webkit-transition: opacity .1s linear;
    transition: opacity .1s linear;
    /*width: 40%;*/
    text-align: right;
    padding-top: 4px;
    background: rgba(255,255,255,0.6);
    padding-left:20px;
    bottom:12px;
  }
  .bottom .card-operation>div{
    float: left;
  }
  .bottom .card-operation .share-button{
    width: 25px;
    height: 25px;
    display: inline-block;
    border-radius: 50%;
    overflow: hidden;
    background-position: center;
    background-size: cover;
  }
  .bottom .card-operation .share{
    /* background-image:url('../assets/favorite-share.png'); */
    background-image:url('../assets/private.png');
    margin-right: 10px;
    padding: 0;
  }
  /*.bottom .card-operation .share:hover{*/
    /*background-image: url('../assets/favorite-share-hover.png');*/
  /*}*/
  .bottom .card-operation .share.hover{
    background-image: url('../assets/favorite-share-hover.png');
  }
  .bottom .card-operation .collection{
    background-image:url('../assets/favorite-coll.png');
  }
  .bottom .card-operation .collection.active{
    background-image:url('../assets/favorite-coll-active.png');
  }
  .share-list{
    position: absolute;
    bottom: 45px;
    right: 3px;
    z-index: 100;
  }
  .card-body{
    height:230px;
    position: absolute;
    top:0;
    width:100%;
    left:0;
    overflow: hidden;
  }
  .web-link{
    /*float: left;*/
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #d3d3d3;
  }
  .web-link >img{
    width: 30px;
    height: 30px;
    display: inline-block;
    margin-right: 4px;
    vertical-align: middle;
    border-radius:4px;
  }
  .web-link > span{
    color: #d3d3d3;
    font-size: 14px;
  }
  .card-info .card-title{
    font-size: 20px;
    color: #333333;
    padding: 20px 20px 0;
    max-height: 60px;
    line-height: 28px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    transition: color .1s linear;
    font-weight:600;
    cursor: pointer;
  }
  .card-info .card-des{
    font-size: 14px;
    color: #747474;
    padding:0 20px ;
    word-wrap: break-word;
    overflow: hidden;
    margin-top: 25px;
    line-height: 20px;
  }
  .bottom {
    position: absolute;
    height: 40px;
    bottom: 0;
    left: 20px;
    right: 20px;
    background: #fff;
    z-index: 100;
    padding-top: 4px;
  }

  .image {
    width:100%;
    height: 170px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
  @media (max-width: 650px) {
    .bottom .card-operation{
      display:block;
      opacity: 1;
    }
  }
</style>
<script>
  import {CollectionPage,CancelCollection} from'@/api/doc';
  import ShareList from '../components/ShareList'
  import {USER_INFO,getArticlePublic}from'@/api/user';

  const _this = this;
  export default {
    name: "FavoriteItem",
    components: {ShareList},
    data() {
      return {
          showListFlag:false,
          isCollection:true,
      };
    },
    mounted (){
    },
    destroyed(){
      this.img = '';
    },
    props:{
      o:{
        link:'',
        id:'',
        title:'',
        orig:'',
        img:'',
        favicon:'',
        desc:'',
        public:false,
        public_url:'',
      },
      isChinese:false
    },
    created(){

    },
    methods: {
      openShare(o){
          if(!o.public){
            getArticlePublic({
              article_id: o.id
            }).then(res=>{
              if(res.rc==0){
                  this.showListFlag = true;
                  this.o.public =true;
                  this.o.public_url = res.article.public_url || '';
              }
            })
          }else{
            this.showListFlag = !this.showListFlag;
          }
      },
      toRead(o){
        this.$router.push({ path: '/read/'+o.id })
      },
      changedata(e){
        this.o.public = false;
        this.o.public_url = '';
        this.showListFlag = false;
      },
      collection (obj) {
        console.log(obj.id);
        let user =USER_INFO()._id;
        if(this.isCollection){
          this.$confirm(this.$t('collection.alert.message')+'?', this.$t('doc.tips'), {
            confirmButtonText: this.$t('collection.alert.sure'),
            cancelButtonText: this.$t('collection.alert.cancel'),
            type: 'warning'
          }).then(() => {

            CancelCollection(user,obj.id).then(res=>{
              if(res.rc ==0){
                // this.isCollection = false;
                this.$emit('refDelItem',{id:obj.id,isCollection:false});
              }
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('collection.alert.message')
            });
          });
        }else{
            CollectionPage(user,obj.link).then(res=>{
              if(res.rc==0){
                this.$emit('refDelItem',{id:obj.id,isCollection:true});
                // this.isCollection = true;
              }
            });
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/FavoriteItem.vue